module.exports = __webpack_public_path__ + "static/media/Login-BG@1x.ab5c215e.jpg";